<template>
  <v-footer
    color="pink accent-4"
    padless
  >
    <v-layout
      justify-center
      wrap
    >
      <v-btn
        v-for="link in links"
        :key="link"
        @click="openLink(link.href)"
        color="white"
        text
        rounded
        class="my-2"
      >
          <font-awesome-icon
            :icon="['fab', link.icon]"
            size="2x"
          ></font-awesome-icon>
      </v-btn>
      <v-flex
        color="pinkaccent-4"
        py-4
        text-center
        white--text
        xs12
      >
        {{ new Date().getFullYear() }} — <strong>
          <a 
            href="http://twitter.com/attackongamez"
            style="text-decoration: none;"
            >
            AttackOnGamez</a></strong>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
  export default {
    data: () => ({
      links: [
        {
          icon:'twitch',
          href: 'https://twitch.tv/attackongamez'
        },
        {
          icon:'twitter',
          href: 'https://twitter.com/attackongamez'
        },
        {
          icon:'instagram',
          href: 'https://instagram.com/brittanysdesigns'
        },
        {
          icon:'discord',
          href: 'https://t.co/ewXmWg2D0n?amp=1'
        },
        {
          icon:'patreon',
          href: 'https://patreon.com/brittanysdesigns'
        },
        {
          icon:'etsy',
          href: 'https://etsy.com/shop/iluffsasuke'
        },
      ],
    }),
    methods: {
      openLink(link) {
        window.open(link, '_blank')
      }
    }
  }
</script>